import React from "react";
import dayjs from "dayjs";
import { genderTypes } from "../../../enum/genderTypes";
import { ethnicityTypes } from "../../../enum/ethnicityType";
import EditSVGLight from "./../../../assets/images/edit-pencil-light.svg";
import EditSVGDark from "./../../../assets/images/edit-pencil-dark.svg";
import { Tooltip, Skeleton } from "@mui/material";
import { getAge } from "../../../utils/getAge";
import useTitanApp from "../../../hooks/useTitanApp";
import { setCurrentShowPatientDetailsEditModal } from "../../../dispatchers/patientDispatchers";

export default function PatientDetails({ onDarkModeChange }) {
  const { patientState, appState } = useTitanApp();
  const { selectedPatient, selectedPatientDetails, isPatientDetailsLoading } =
  patientState || {};
  const { darkMode } = appState || {};
  const theme = {
    color: `${onDarkModeChange.onDarkModeChange === false ? "#000" : "#fff"}`,
  };

  const patientDetails = [];

  if (selectedPatientDetails) {
    patientDetails.push(
      {
        label: "Name",
        value: `${selectedPatient || ""}`,
      },
      {
        label: "Date of Birth",
        value: `${dayjs(selectedPatientDetails?.dob).format(
          "DD/MM/YYYY"
        )} (${getAge(selectedPatientDetails?.dob)})`,
      },
      {
        label: "Gender",
        value: genderTypes[selectedPatientDetails?.sex],
      },
      {
        label: "NHS Number",
        value: selectedPatientDetails?.nhsNumber || "Not available",
      },
      {
        label: "Address",
        value: selectedPatientDetails?.address || "Not available",
      }
    );

    // Conditionally add Ethnicity if not zero
    if (
      selectedPatientDetails?.ethnicity &&
      selectedPatientDetails?.ethnicity !== 0
    ) {
      patientDetails.push({
        label: "Ethnicity",
        value: ethnicityTypes[selectedPatientDetails?.ethnicity],
      });
    }
    if (
      selectedPatientDetails?.allergies &&
      selectedPatientDetails?.allergies?.length > 0
    ) {
      patientDetails.push({
        label: "Allergies",
        value:
          Array.isArray(selectedPatientDetails?.allergies) &&
          selectedPatientDetails?.allergies?.length > 0
            ? selectedPatientDetails.allergies.map((a) => a?.allergyName)
            : ["-"],
      });
    }
  }
  async function handleEditPatient() {
    setCurrentShowPatientDetailsEditModal(true);
  }

  return (
    <React.Fragment>
      <div className="tasks_header header_appointment">
        <h3 className="pharmacy_header_name">Patient Details</h3>
        <Tooltip title="Update Patient" arrow>
          <div
            onClick={handleEditPatient}
            style={{ cursor: "pointer" }}
            role="button"
            aria-label="Edit Patient"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") handleEditPatient();
            }}
          >
            {darkMode ? <EditSVGLight /> : <EditSVGDark />}
          </div>
        </Tooltip>
      </div>
      <div className="wrapper patient-details-container" id="patient-details-wrapper">
        {patientDetails.map((detail, index) => (
          <div
            className={`col-box patient-detail-box ${
              detail.label === "Address" && "address-box"
            }`}
            key={index}
          >
            <div className="box-label">
              <p className="patient-detail-label">{detail?.label}</p>
              {isPatientDetailsLoading ? (
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height={30}
                  sx={{
                    width: "100%",
                    bgcolor: darkMode ? "grey.800" : "",
                    borderRadius: "5px",
                  }}
                />
              ) : Array.isArray(detail.value) ? (
                <div className="value allergies">
                  {detail?.value.map((v, i) => (
                    <p key={i}>{v}</p>
                  ))}
                </div>
              ) : (
                <p className="value">{detail?.value}</p>
              )}
            </div>
            {/* <LiaCopy size={22} className="icons-color" /> */}
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

